import { formatRelativeTime } from "@/lib/formatRelativeTime";

export function HeartbeatValue({ lastSeenAt }: { lastSeenAt: string | null }) {
  if (!lastSeenAt) {
    return <span className="text-foreground/70">Never</span>;
  }

  return (
    <>
      <span className="tabular-nums">{formatRelativeTime(lastSeenAt)}</span>
      <span className="block text-xs tabular-nums text-foreground/70">
        {new Date(lastSeenAt).toLocaleString(undefined, {
          day: "numeric",
          month: "short",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        })}
      </span>
    </>
  );
}
